/** @typedef {import('./comment-votes-service').default} CommentVotesService */

/* eslint-disable no-underscore-dangle */
export default class CommentVotesRepository {
  /**
   * Creates an instance of CommentVotesRepository.
   * @param {Object} settings
   * @param {CommentVotesService} settings.service
   * @memberof CommentVotesRepository
   */
  constructor({ service }) {
    this._service = service
  }

  /**
   * @param {Number} commentId
   * @memberof CommentVotesRepository
   */
  async voteUp(commentId) {
    return this._service.vote(commentId, 1)
  }

  /**
   * @param {Number} commentId
   * @memberof CommentVotesRepository
   */
  async voteDown(commentId) {
    return this._service.vote(commentId, -1)
  }

  /**
   * @param {Number} commentId
   * @memberof CommentVotesRepository
   */
  async undoUpvote(commentId) {
    return this._service.undo(commentId, 1)
  }

  /**
   * @param {Number} commentId
   * @memberof CommentVotesRepository
   */
  async undoDownvote(commentId) {
    return this._service.undo(commentId, -1)
  }
}
